import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { WithStyles } from 'shared/decorators/withStyles';
import { SvgIcon } from 'components/SvgIcon';
import { configService } from 'services/ConfigService';
import { timerService } from 'services/TimerService';
import { cartService } from 'services/CartService';

interface IState extends IStateBase {
  timer: number;
  minutes: any;
  seconds: any;
  isTimeOver: boolean;
  contentId: string;
}

@WithStyles(() => ({
  component: {
    backgroundColor: 'rgba(255, 152, 0, .8)',
    position: 'fixed',
    width: '100%',
    zIndex: 2,
    color: '#FFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 65,

    '& .time': {
      fontWeight: 'bold',
      fontSize: '1.8rem',
      margin: '0 18px',
      '@media screen and (max-width: 600px)': {
        fontSize: '1.2rem'
      }
    },

    '& .timerDescription': {
      color: '#FFF',
      display: 'flex',
      alignItems: 'center',
      '@media screen and (max-width: 600px)': {
        maxWidth: '50%'
      },

      '& .text': {
        maxWidth: 280,
        '@media screen and (max-width: 600px)': {
          fontSize: '0.6rem'
        }
      },

      '& svg': {
        fill: '#FFF',
        width: 45,
        margin: '8px 10px 0 0',
        '@media screen and (max-width: 600px)': {
          width: '35px'
        }
      }
    }
  }
}))
export class Timer extends BaseComponent<IState, {}> {
  constructor(props: any) {
    super(props);
    this.state = { contentId: null, timer: 0, minutes: '', seconds: '', isTimeOver: false };
  }

  componentDidMount() {
    cartService
      .getCart()
      .take(1)
      .filter(cart => !!cart.contentId)
      .map(cart => cart.contentId)
      .combineLatest(configService.getConfig())
      .bindComponent(this)
      .subscribe(([contentId, config]) => {
        this.setState({ timer: config.timer });

        if (config.timer) {
          const currentTime = Number(window.localStorage.getItem(`${contentId}-sun-scarcity-time`));

          timerService.setTimeLeft(currentTime || config.timer * 60);
          timerService.setReserveTime(config.timer);
        }
      });

    timerService
      .getIsOver()
      .bindComponent(this)
      .subscribe(isTimeOver => {
        this.setState({ isTimeOver });
      });

    timerService
      .calculateTime()
      .distinctUntilChanged()
      .bindComponent(this)
      .subscribe(timer => {
        const minutes = ('0' + Math.floor(timer / 60)).slice(-2);
        const seconds = ('0' + ((timer / 60 - Math.floor(timer / 60)) * 60).toFixed(0)).slice(-2);
        this.setState({ timer, minutes, seconds });
      });
  }

  render() {
    if (!this.state) {
      return null;
    }

    const { timer, minutes, seconds, isTimeOver } = this.state;

    if (!timer) {
      return null;
    }

    return (
      <div className={`${this.props.classes.component} scarcity-timer`}>
        <div className="time">
          00 : {isTimeOver ? '00' : minutes} : {isTimeOver ? '00' : seconds}
        </div>
        <div className="timerDescription">
          <SvgIcon name="timer" />
          <span className="text">
            {isTimeOver
              ? 'Estou aguardando sua confirmação... Não perca essa oportunidade!'
              : 'Aproveite essa super oferta! Conclua sua compra para acesso imediato'}
          </span>
        </div>
      </div>
    );
  }
}
